// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"631":"e8cf43da","729":"9c3d045d"}[chunkId] + ".chunk.css";
};